export default {
    data() {
        return {
            swiperOptions: {
                slidesPerView: 2,
                spaceBetween: 114,
                grabCursor: true,
                resizeObserver: true,
                updateOnWindowResize: true,
                breakpoints: {
                    1870: {
                        spaceBetween: 80,
                    },
                    1300: {
                        spaceBetween: 72,
                    },
                    1160: {
                        spaceBetween: 64,
                    },
                    920: {
                        spaceBetween: 16,
                        slidesPerView: 'auto',
                    },
                },
            },
            taskSwiperOptions: {
                slidesPerView: 2,
                spaceBetween: 114,
                grabCursor: true,
                resizeObserver: true,
                updateOnWindowResize: true,
                breakpoints: {
                    1870: {
                        spaceBetween: 80,
                    },
                    1300: {
                        spaceBetween: 72,
                    },
                    1160: {
                        spaceBetween: 64,
                        direction: 'horizontal',
                    },
                    920: {
                        direction: 'vertical',
                        spaceBetween: 0,
                        slidesPerView: 4,
                        slidesOffsetAfter: 300,
                    },
                },
            },
            verticalOptions: {
                slidesPerView: 3,
                spaceBetween: 72,
                grabCursor: true,
                resizeObserver: true,
                updateOnWindowResize: true,
                direction: 'vertical',

                // autoHeight: true
            },
        };
    },
    methods: {},
};
